module.exports = __webpack_public_path__ + "src/assets/sounds/stopwatch_sound.mp3";